import axiosClient from './axiosClient';

const paymentApi = {
    requestWithdraw: (data) => {
        const baseURL = 'payment/withdraw';
        return axiosClient.post(baseURL, {
            requestInfo: data.requestInfo,
            OTPCode: data.OTPCode,
            isMiddleware: true,
            saveBankInfo: data.saveBankInfo,
        });
    },
    myWithdrawRequest: () => {
        const baseURL = 'payment/withdraw';
        return axiosClient.get(baseURL);
    },
    // Hạn mức rút tiền admin cấu hình: { minAmount, maxAmount }
    withdrawLimits: () => {
        return axiosClient.get('payment/withdraw-limits');
    },
};

export default paymentApi;
